import { Row } from "@tanstack/react-table";

import { ControlResultIdAndStepIndex } from "api/generated/model";

import { ControlResultRow } from "./useUserControlResultListTable";

export function buildPatchControlResultsBody(
    selectedRows: Row<ControlResultRow>[]
): ControlResultIdAndStepIndex[] {
    return selectedRows.map(({ original }) => ({
        controlResultId: original.controlResultId,
        stepIndex: original.stepIndex,
    }));
}
